import { Link } from "react-router-dom";
import styles from "./styles.module.css";

const NavItem = ({ label, path, children, submenuKey, exactMatch = false, location, hoveredMenu, setHoveredMenu, isActive }) => {
  const hasSubmenu = children && children.length > 0;

  // If has submenu, check if any child is active
  const childActive = hasSubmenu && children.some(child => isActive(child.path));
  const active = exactMatch ? location.pathname === path : (childActive || isActive(path));

  const showSubmenu = hoveredMenu === submenuKey;

  return (
    <li
      className={styles.navItem}
      onMouseEnter={() => hasSubmenu && setHoveredMenu(submenuKey)}
      onMouseLeave={() => hasSubmenu && setHoveredMenu(null)}
    >
      <Link
        to={path}
        className={`${styles.navLink} ${active ? styles.navLinkActive : styles.navLinkInactive}`}
      >
        {label}
        {active && (
          <span className={styles.activeIndicator} />
        )}
      </Link>

      {hasSubmenu && (
        <ul className={`${styles.dropdown} ${showSubmenu ? styles.dropdownVisible : styles.dropdownHidden}`}>
          {children.map((child, index) => (
            <li key={index}>
              <Link
                to={child.path}
                className={`
                    ${styles.dropdownItem}
                    ${isActive(child.path) ? styles.dropdownItemActive : styles.dropdownItemInactive}
                    ${index === 0 ? styles.dropdownItemFirst : ''}
                    ${index === children.length - 1 ? styles.dropdownItemLast : ''}
                  `}
              >
                {child.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default NavItem;